import { getLabel } from "../labels";

export function getDayDesc(day) {
    switch (day) {
        case 1:
        return getLabel('general.week_days_short.mon');
        case 2:
        return getLabel('general.week_days_short.tue');
        case 3:
        return getLabel('general.week_days_short.wed');
        case 4:
        return getLabel('general.week_days_short.thu');
        case 5:
        return getLabel('general.week_days_short.fri');
        case 6:
        return getLabel('general.week_days_short.sat');
        case 7:
        return getLabel('general.week_days_short.sun');
        default:
        return '';
    }
}
